import classnames from "classnames";

import styles from "./Bids.module.scss";
import { useContext, useEffect } from "react";
import { Context } from "pages/Dashboard/Dashboard";
import { fetchBidsData } from "pages/Dashboard/utils";

const Bids = ({ setShowDetailedInfo, setSelectedBid }) => {
  const { bidsData, setBidsData } = useContext(Context);
  const handleBidClick = (bidId) => {
    setShowDetailedInfo(true);
    setSelectedBid(bidId);
  };

  useEffect(() => {
    fetchBidsData({ setBidsData });
  }, [setBidsData]);

  return (
    <div className={styles.wrapper}>
      <div className={styles.header}>
        <div className={styles.cell}>Bided Time</div>
        <div className={styles.cell}>Customer Name/ Email</div>
        <div className={styles.cell}>From/ To</div>
        <div className={styles.cell}>Cust.Rate/ Driv.Rate</div>
      </div>
      <div className={styles.list}>
        {bidsData.map((bid, index) => {
          return (
            <div
              className={styles.item}
              key={index}
              onClick={() => handleBidClick(bid.id)}
            >
              <div className={styles.cell}>{bid.bided_time.split(" ")[1]}</div>
              <div className={classnames(styles.cell, styles.longName)}>
                {bid.customer_name} <br /> {bid.agent_email}
              </div>
              <div className={styles.cell}>
                {bid.pick_up_state}-{bid.delivery_state}
              </div>
              <div className={styles.cell}>
                ${bid.customer_rate} <br />${bid.driver_rate}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Bids;
